import { createFileRoute } from "@tanstack/react-router";
import { Panel } from "~/components/ui/page";
import { CompanySettingsForm } from "~/features/settings/company-form";
import { SettingsSection } from "~/features/settings/section";
import { SerialTrackingSettings } from "~/features/settings/serial-tracking-settings";
import { useT } from "~/lib/i18n";

export const Route = createFileRoute("/_app/settings/stock")({ component: StockSettingsPage });

function StockSettingsPage() {
  const t = useT();
  return (
    <>
      <Panel>
        <SettingsSection title={t("stock.serials.title")}>
          <SerialTrackingSettings />
        </SettingsSection>
      </Panel>
      <CompanySettingsForm>
        {({ check }) => (
          <Panel>
            <SettingsSection title={t("settings.replenishTitle")}>
              {check("autoReplenish", t("company.autoReplenish"), t("settings.autoReplenishHint"))}
            </SettingsSection>
          </Panel>
        )}
      </CompanySettingsForm>
    </>
  );
}
